"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var cardDetailApi = _interopRequireWildcard(require("@/api/cardDetailApi"));
var projectApi = _interopRequireWildcard(require("@/api/projectManageApi"));
var _static = require("@/views/orderList/order/static");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      visible: false,
      loading: false,
      tableLoading: false,
      empIntegralId: null,
      cardType: null,
      cardDetail: {
        id: '',
        projectType: '',
        projectStatus: '',
        cardStatus: '未知状态',
        projectName: '',
        projectId: '',
        projectNumber: '',
        applicationNumber: '',
        customerName: '',
        relatedCard: '',
        releaseTime: '',
        validityPeriod: '',
        faceValue: '',
        availableAmount: '',
        miniappName: '',
        projectRemark: '',
        internalRemark: '',
        cardPackageId: '',
        cardPackageName: ''
      },
      transactionData: [],
      pagination: {
        page: 1,
        limit: 20,
        total: 0
      }
    };
  },
  methods: {
    openDetail: function openDetail(empIntegralId, cardStatus, type) {
      this.empIntegralId = empIntegralId;
      this.visible = true;
      this.cardType = type;

      // If cardStatus is provided from list view, store it directly
      if (cardStatus !== undefined) {
        this.cardDetail.cardStatus = cardStatus;
      }
      this.fetchCardDetail();
      this.fetchTransactionData();
    },
    fetchCardDetail: function fetchCardDetail() {
      var _this = this;
      this.loading = true;

      // 使用cardDetailApi中的getCardDetail方法
      cardDetailApi.getCardDetail(this.empIntegralId).then(function (res) {
        if (res) {
          var detail = res;

          // 移除状态中的多余点号
          var cleanStatus = detail.projectStatus ? detail.projectStatus.replace(/\.+$/, '') : '-';

          // 格式化数据
          _this.cardDetail = {
            id: _this.empIntegralId || '-',
            projectType: detail.projectType || '-',
            projectStatus: cleanStatus || '-',
            // Keep existing cardStatus if it was passed in, otherwise use default
            cardStatus: _this.cardDetail.cardStatus || '未知状态',
            projectName: detail.projectName || '-',
            projectId: detail.projectId || '-',
            projectNumber: detail.projectNumber || '-',
            applicationNumber: detail.applicationNumber || '-',
            customerName: detail.customerName || '-',
            relatedCard: detail.cardName || '-',
            releaseTime: detail.grantTime ? _this.formatDateTime(detail.grantTime) : '-',
            validityPeriod: detail.dueTime ? _this.formatDateTime(detail.dueTime) : '-',
            faceValue: _this.formatMoney(detail.parAmount || 0),
            availableAmount: _this.formatMoney(detail.balance || 0),
            miniappName: detail.appName || '-',
            projectRemark: detail.projectRemark || '-',
            internalRemark: detail.innerRemark || '-',
            cardPackageId: detail.cardPackageId || '-',
            cardPackageName: detail.cardPackageName || '-'
          };
        } else {
          _this.$message.error(res && res.message ? res.message : '获取卡片详情失败');
        }
        _this.loading = false;
      }).catch(function (err) {
        console.error('获取卡片详情失败', err);
        _this.$message.error('获取卡片详情失败');
        _this.loading = false;
      });
    },
    fetchTransactionData: function fetchTransactionData() {
      var _this2 = this;
      this.tableLoading = true;
      // 构造查询参数
      var params = {
        empIntegralId: this.empIntegralId,
        page: this.pagination.page,
        limit: this.pagination.limit
      };

      // 调用API获取交易记录
      cardDetailApi.getCardTransactions(params).then(function (res) {
        if (res && res.page) {
          _this2.transactionData = res.page.list || [];
          _this2.pagination.total = res.page.total || 0;
        } else {
          _this2.$message.error('获取交易记录失败');
          _this2.transactionData = [];
          _this2.pagination.total = 0;
        }
        _this2.tableLoading = false;
      }).catch(function (err) {
        _this2.$message.error('获取交易记录失败');
        _this2.transactionData = [];
        _this2.pagination.total = 0;
        _this2.tableLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.limit = val;
      this.fetchTransactionData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchTransactionData();
    },
    getStatusTypeFromName: function getStatusTypeFromName(statusName) {
      var typeMap = {
        '未绑定': 'info',
        '已绑定': 'success',
        '作废': 'danger',
        '部分作废': 'warning',
        '未发放': 'info',
        '已发放': 'primary',
        '未知状态': 'info'
      };
      return typeMap[statusName] || 'info';
    },
    getStatusIconFromName: function getStatusIconFromName(statusName) {
      var iconMap = {
        '未绑定': 'el-icon-circle-check',
        '已绑定': 'el-icon-circle-check',
        '作废': 'el-icon-circle-close',
        '部分作废': 'el-icon-warning',
        '未发放': 'el-icon-time',
        '已发放': 'el-icon-check',
        '未知状态': 'el-icon-question'
      };
      return iconMap[statusName] || '';
    },
    formatDateTime: function formatDateTime(dateTime) {
      if (!dateTime) return '-';

      // 如果是Date对象，格式化为字符串
      if (dateTime instanceof Date) {
        var year = dateTime.getFullYear();
        var month = String(dateTime.getMonth() + 1).padStart(2, '0');
        var day = String(dateTime.getDate()).padStart(2, '0');
        var hours = String(dateTime.getHours()).padStart(2, '0');
        var minutes = String(dateTime.getMinutes()).padStart(2, '0');
        var seconds = String(dateTime.getSeconds()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      }

      // 如果已经是格式化的字符串，直接返回
      return dateTime;
    },
    formatMoney: function formatMoney(amount) {
      if (!amount && amount !== 0) return '¥0';
      if (typeof amount === 'string') {
        // 移除非数字字符(除了小数点)
        var value = amount.replace(/[^\d.]/g, '');
        return '¥ ' + value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else if (typeof amount === 'number') {
        return '¥ ' + amount.toLocaleString();
      }
      return '¥ ' + amount;
    },
    copyCardInfo: function copyCardInfo() {
      var _this3 = this;
      try {
        // Format card info as text
        var cardInfo = "\n\u5361\u7247ID: ".concat(this.cardDetail.id, "\n\u9879\u76EE\u7C7B\u578B: ").concat(this.cardDetail.projectType, "\n\u9879\u76EE\u72B6\u6001: ").concat(this.cardDetail.projectStatus, "\n\u9879\u76EE\u540D\u79F0: ").concat(this.cardDetail.projectName, "\n\u5361\u7247\u72B6\u6001: ").concat(this.cardDetail.cardStatus, "\n\u5F52\u5C5E\u5BA2\u6237: ").concat(this.cardDetail.customerName, "\n\u5173\u8054\u798F\u5361: ").concat(this.cardDetail.relatedCard, "\n\u53D1\u653E\u5C0F\u7A0B\u5E8F: ").concat(this.cardDetail.miniappName, "\n\u53D1\u653E\u65F6\u95F4: ").concat(this.cardDetail.releaseTime, "\n\u6709\u6548\u671F\u9650: ").concat(this.cardDetail.validityPeriod, "\n\u5361\u7247\u9762\u503C: ").concat(this.cardDetail.faceValue, "\n\u53EF\u7528\u4F59\u989D: ").concat(this.cardDetail.availableAmount, "\n\u9879\u76EE\u5907\u6CE8: ").concat(this.cardDetail.projectRemark || '无', "\n\u5185\u90E8\u5907\u6CE8: ").concat(this.cardDetail.internalRemark || '无');

        // Only include card package info if cardType is 3
        if (this.cardType === 3) {
          cardInfo += "\n\u5173\u8054\u798F\u5361ID: ".concat(this.cardDetail.cardPackageId || '无', "\n\u5173\u8054\u798F\u5361\u540D\u79F0: ").concat(this.cardDetail.cardPackageName || '无');
        }

        // Copy to clipboard
        navigator.clipboard.writeText(cardInfo.trim()).then(function () {
          _this3.$message({
            message: '卡片信息已复制到剪贴板',
            type: 'success',
            duration: 2000
          });
        });
      } catch (err) {
        console.error('复制到剪贴板失败:', err);
        this.$message.error('复制失败');
      }
    }
  }
};